import suv from 'public/static/images/used_cars_welcome/suv.jpg';
import electric from 'public/static/images/used_cars_welcome/electric.jpg';
import hybrid from 'public/static/images/used_cars_welcome/hybrid.jpg';
import truck from 'public/static/images/used_cars_welcome/truck.jpg';
import sports from 'public/static/images/used_cars_welcome/sports.jpg';
import coupe from 'public/static/images/used_cars_welcome/coupe.jpg';
import sedan from 'public/static/images/used_cars_welcome/sedan.jpg';
import hatchback from 'public/static/images/used_cars_welcome/hatchback.jpg';
import convertible from 'public/static/images/used_cars_welcome/convertible.jpg';
import minivan from 'public/static/images/used_cars_welcome/minivan.jpg';

const categories = [
  {
    value: 'suv',
    image: suv,
    label: 'SUVs',
  },
  {
    value: 'Electric',
    image: electric,
    label: 'EVs',
  },
  {
    value: 'Hybrid',
    image: hybrid,
    label: 'Hybrids',
  },
  {
    value: 'truck',
    image: truck,
    label: 'Trucks',
  },
  {
    value: 'Sport',
    image: sports,
    label: 'Sports',
  },
  {
    value: 'sedan',
    image: sedan,
    label: 'Sedans',
  },
  {
    value: 'hatchback',
    image: hatchback,
    label: 'Hatchbacks',
  },
  {
    value: 'coupe',
    image: coupe,
    label: 'Coupes',
  },
  {
    value: 'convertible',
    image: convertible,
    label: 'Convertibles',
  },
  {
    value: 'minivan',
    image: minivan,
    label: 'Minivans',
  },
];

export default categories;
